import React from "react";
import MaterialProgress from "components/MaterialProgress/MaterialProgress";
import { PlantItem } from "components/StyledComponents";
import ItemShipmentQuantitySubscriber from "./ItemShipmentQuantitySubscriber";

// The quantity on screen comes from the PLANT_LOCATIONS query (httpClient cache),
// which the subscriber below patches on every event. Keeping the progress JSX out
// of a render-prop arrow also avoids a production babel bug
// (transform-react-constant-elements hoisting a prop-only element out of the
// nested arrow).
const ProgressSubscriptionWrapper = ({
  concreteShipmentId,
  inventoryItem,
}) => (
  <PlantItem>
    <ItemShipmentQuantitySubscriber
      inventoryItemId={inventoryItem.id}
      concreteShipmentId={concreteShipmentId}
    />
    <MaterialProgress
      title={inventoryItem.name}
      value={inventoryItem.itemShipmentQuantity || 0}
      total={inventoryItem.shipmentMaterial ? inventoryItem.shipmentMaterial.formulaWeight : 0}
    />
  </PlantItem>
);

export default ProgressSubscriptionWrapper;
